// extracted by mini-css-extract-plugin
export default {"dropdown":"BehaviorAndScope_dropdown__-dgL4"};